import SearchableSelect from './SearchableSelect';

type OrganizationPickerProps = {
  organizations: any[];
  value: string | number | null | undefined;
  onChange: (value: string) => void;
  ariaLabel?: string;
  includeNone?: boolean;
  noneLabel?: string;
  disabled?: boolean;
  placeholder?: string;
};

function OrganizationPicker({
  organizations,
  value,
  onChange,
  ariaLabel = "Organization",
  includeNone = false,
  noneLabel = "None",
  disabled = false,
  placeholder = "Select organization"
}: OrganizationPickerProps) {
  return (
    <SearchableSelect
      options={organizations.map((organization: any) => ({
        value: organization.id,
        label: organization.name
      }))}
      value={value}
      onChange={onChange}
      ariaLabel={ariaLabel}
      includeEmptyOption={includeNone}
      emptyOptionLabel={noneLabel}
      disabled={disabled}
      placeholder={placeholder}
      searchPlaceholder="Search organizations..."
    />
  );
}

export default OrganizationPicker;
